
// import React from 'react';
// import Lottie from 'react-lottie';
// import animationData from './Animation - 1729034692586.json';

// const BookingBox = ({ openModal }) => {
//   return (
//     <div className="bg-gray-400 p-6 rounded-lg shadow-lg w-full max-w-md">
//       <h2 className="text-white text-2xl font-bold mb-4 text-center">Book Your Service</h2>
//       <div className="flex flex-col space-y-4">
//         <button
//           onClick={() => openModal('truck')}
//           className="mt-4 px-4 py-2 bg-black text-white rounded hover:bg-gray-500 hover:text-gray-200 hover:scale-105 transition-all duration-1000 delay-100 hover:shadow-xl"
//         >
//           Book a Truck
//         </button>
//         <button
//           onClick={() => openModal('trailer')}
//           className="mt-4 px-4 py-2 bg-black text-white rounded hover:bg-gray-500 hover:text-gray-200 hover:scale-105 transition-all duration-1000 delay-100 hover:shadow-xl"
//         >
//           Book a Trailer
//         </button>
//       </div>
//     </div>
//   );
// };

// const Image = ({ openModal }) => {
//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: animationData,
//     rendererSettings: {
//       preserveAspectRatio: 'xMidYMid slice',
//     },
//   };

//   return (
//     <div className="relative w-full h-screen flex">
//       <div className="relative z-10 w-1/2 flex justify-center items-center">
//         <BookingBox openModal={openModal} />
//       </div>
//       <div className="absolute right-0 w-1/2 h-full z-10">
//         <Lottie className="rounded" options={defaultOptions} height="100%" width="100%" />
//       </div>
//     </div>
//   );
// };

// export default Image;


// import React from "react";
// import Lottie from "react-lottie";
// import animationData from "./Animation - 1729034692586.json";

// const HeroSection = ({ openModal }) => {
//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData,
//     rendererSettings: {
//       preserveAspectRatio: "xMidYMid meet",
//     },
//   };

//   return (
//     <section className="relative min-h-screen bg-white overflow-hidden">
//       <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 items-center gap-16">

//         {/* LEFT CONTENT */}
//         <div className="z-10">
//           <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
//             Smart & Reliable Logistics,<br />
//             Delivered on Time.
//           </h1>

//           <p className="mt-5 text-lg text-gray-600 max-w-xl">
//             Book trucks and trailers instantly with verified transport partners,
//             transparent pricing, and seamless coordination across India.
//           </p>

//           {/* CTA BUTTONS */}
//           <div className="mt-8 flex flex-wrap gap-4">
//             <button
//               onClick={() => openModal("truck")}
//               className="bg-blue-600 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-700 transition shadow-sm"
//             >
//               Book a Truck
//             </button>

//             <button
//               onClick={() => openModal("trailer")}
//               className="border border-gray-300 text-gray-700 px-6 py-3 rounded-md font-medium hover:border-blue-600 hover:text-blue-600 transition"
//             >
//               Book a Trailer
//             </button>
//           </div>

//           {/* TRUST STRIP */}
//           <div className="mt-10 grid grid-cols-2 gap-4 text-sm text-gray-600 max-w-md">
//             <div>✔ 10,000+ Deliveries</div>
//             <div>✔ Pan-India Network</div>
//             <div>✔ Verified Partners</div>
//             <div>✔ Real-Time Coordination</div>
//           </div>
//         </div>

//         {/* RIGHT GIF */}
//         <div className="relative flex justify-center items-center">
//           <div className="w-full max-w-xl">
//             <Lottie options={defaultOptions} />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;


import React from "react";
import Lottie from "react-lottie";
import animationData from "./Animation - 1729034692586.json";

const HeroSection = ({ openModal }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  return (
    <section className="relative bg-gradient-to-b from-blue-50 to-white overflow-hidden">

      {/* HERO */}
      <div className="relative max-w-7xl mx-auto px-6 pt-24 pb-20 grid grid-cols-1 md:grid-cols-2 items-center gap-20">

        {/* LEFT */}
        <div>
          <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
            Smart & Reliable Logistics,<br />
            Delivered on Time.
          </h1>

          <p className="mt-6 text-lg text-gray-600 max-w-xl leading-relaxed">
            Book trucks and trailers instantly with verified transport partners,
            transparent pricing, and seamless coordination across India.
          </p>

          <div className="mt-10 flex gap-5">
            <button
              onClick={() => openModal("truck")}
              className="bg-blue-600 text-white px-7 py-3 rounded-lg font-medium hover:bg-blue-700 transition"
            >
              Book a Truck
            </button>

            <button
              onClick={() => openModal("trailer")}
              className="border border-gray-300 text-gray-700 px-7 py-3 rounded-lg font-medium hover:border-blue-600 hover:text-blue-600 transition"
            >
              Book a Trailer
            </button>
          </div>
        </div>

        {/* RIGHT */}
        <div className="flex justify-center">
          <div className="w-full max-w-xl">
            <Lottie options={defaultOptions} />
          </div>
        </div>
      </div>

      {/* HOW IT WORKS — SAME COMPONENT */}
      <div className="relative bg-white">
        <div className="max-w-7xl mx-auto px-6 py-20">

          {/* Section Heading */}
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-semibold text-gray-900">
              How It Works
            </h2>
            <p className="mt-3 text-gray-600 text-lg">
              Simple, transparent, and efficient logistics in three easy steps.
            </p>
          </div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

            {/* Step 1 */}
            <div className="bg-gray-50 p-8 rounded-xl text-center">
              <div className="text-blue-600 text-4xl font-semibold mb-4">01</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Choose Your Service
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Select a truck or trailer based on your transportation needs and cargo type.
              </p>
            </div>

            {/* Step 2 */}
            <div className="bg-gray-50 p-8 rounded-xl text-center">
              <div className="text-blue-600 text-4xl font-semibold mb-4">02</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Share Pickup & Delivery Details
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Provide pickup location, drop destination, and preferred schedule.
              </p>
            </div>

            {/* Step 3 */}
            <div className="bg-gray-50 p-8 rounded-xl text-center">
              <div className="text-blue-600 text-4xl font-semibold mb-4">03</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                We Handle the Logistics
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Our team coordinates the transport and ensures safe, on-time delivery.
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
